import { MapsAPILoader, MouseEvent } from '@agm/core';
import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';

@Component({
  selector: 'tc-add-geo-location-modal',
  templateUrl: './add-geo-location-modal.component.html'
})
export class AddGeoLocationModalComponent implements OnInit {
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() locationData: any;
  zoom: number;
  address: string;
  private geoCoder;
  @ViewChild('search') searchElementRef: ElementRef;


  constructor(
      private mapsAPILoader: MapsAPILoader,
      private ngZone: NgZone,
      private dataStore: DataStoreService,
  ) { }

  ngOnInit() {
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });
  }

  /*markerDragEnd($event: MouseEvent) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }*/

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }

  public onClose($event: MouseEvent) {
    this.dataStore.set(DataKey.popupClose, true);
  }

  onSave() {
    if(this.locationData) {
      this.locationData.longitude = this.longitude;
      this.locationData.latitude = this.latitude;
    }
    this.dataStore.set(DataKey.geoCodes, this.locationData, true);
    this.dataStore.set(DataKey.popupClose, true);
  }
  isEnableSaveButton(){
    return this.longitude && this.latitude;
  }


}
